import React from 'react';
import styles from './hoverSmallProfile.module.css';
import Avatar from '@mui/material/Avatar';

function HoverSmallProfile({ name, titleOrOccupation, collegeOrCompany, majorInCollegeOrSpecialisation, profilePicUrl }) {
  return (
    <div className={styles.hover_card}>
      <Avatar className={styles.profile_avatar} src={profilePicUrl} alt={name} />
      <div className={styles.profile_info}>
        <p className={styles.profile_name}>{name}</p>
        <p className={styles.profile_title}>{titleOrOccupation}</p>
        <p className={styles.profile_college}>{collegeOrCompany}</p>
        <p className={styles.profile_major}>{majorInCollegeOrSpecialisation}</p>
      </div>
    </div>
  );
}

export default HoverSmallProfile;